'use strict';

document.addEventListener('DOMContentLoaded', function() {
    var screenSet = document.getElementById('gigyaScreenSet').value;
    var startScreen = document.getElementById('gigyaStartScreen').value;
    var containerId = document.getElementById('gigyaContainerId').value;
    if (typeof gigya !== 'undefined') {
        gigya.accounts.showScreenSet({
            'screenSet': screenSet,
            'startScreen': startScreen,
            'containerID': containerId
        });
    }
});
